import type { LeadEventParams } from "../types";

import { identifyAnonymous, track } from "../core";

const LeadEvents = {
  LEAD_CREATED: "sf-lead-created",
};

const commonLeadParams = ({
  leadId,
  organizationNumber,
  selectedOptions,
  recipient,
  formVariant,
  formVersionId,
  surface,
  tags,
}: LeadEventParams) => {
  return {
    form_variant: formVariant,
    ...(formVersionId ? { form_version_id: formVersionId } : {}),
    franchise_number: organizationNumber,
    ...(leadId ? { lead_id: leadId } : {}),
    recipient,
    selected_options: selectedOptions,
    ...(surface ? { surface } : {}),
    ...(tags ? { tags } : {}),
  };
};

// lead was created (client-side tracking - should also happen in the API)
const trackLeadCreated = (leadParams: LeadEventParams) => {
  track(LeadEvents.LEAD_CREATED, {
    element_name: "schedule-call",
    event: LeadEvents.LEAD_CREATED,
    ...commonLeadParams(leadParams),
  });
};

const identifyLead = async (leadIdentityParams: {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}) => identifyAnonymous(leadIdentityParams);

export { identifyLead, trackLeadCreated };
